import { useMemo } from 'react'
import { useChainId } from 'wagmi'

import { FetchFeeDataApiResult } from 'types/entities'

import { useGetFeeDataQuery } from 'state/feeDataApi'

import { CHAIN_INFO } from 'constants/chains'

export function useGasFetcher() {
  const chainId = useChainId()
  const feeData = useGetFeeDataQuery(
    { chainId },
    { pollingInterval: CHAIN_INFO[chainId].blockDuration / 2, skip: !CHAIN_INFO[chainId] },
  )

  const formatGasParams = (gasData?: FetchFeeDataApiResult) => {
    if (gasData?.maxPriorityFeePerGas && gasData?.maxFeePerGas) {
      return {
        maxFeePerGas: BigInt(gasData.maxFeePerGas),
        maxPriorityFeePerGas: BigInt(gasData.maxPriorityFeePerGas),
      }
    } else if (gasData?.gasPrice) {
      return {
        gasPrice: BigInt(gasData.gasPrice),
      }
    }

    return undefined
  }

  const gasParams = useMemo(() => formatGasParams(feeData.data), [feeData.data])

  const getGasParams = async () => {
    const { data } = await feeData.refetch()

    return formatGasParams(data)
  }

  return useMemo(
    () => ({
      gasParams,
      getGasParams,
      data: feeData.data,
      refetch: feeData.refetch,
      isLoading: feeData.isLoading,
      cost: gasParams?.maxFeePerGas || gasParams?.gasPrice,
    }),
    [gasParams, getGasParams, feeData],
  )
}
